export type ContextKey = {
  name: string
  values: string[]
  defaultValue?: string
}

export const RESERVED_CONTEXT_KEY_NAMES = ['pbstck_ab_test']
